var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0613 5.85156H6.47922C5.98046 5.85156 5.50212 6.0497 5.14945 6.40238C4.79677 6.75505 4.59863 7.23339 4.59863 7.73215V20.8963C4.59863 21.3951 4.79677 21.8734 5.14945 22.2261C5.50212 22.5788 5.98046 22.7769 6.47922 22.7769H19.6434C20.1421 22.7769 20.6205 22.5788 20.9731 22.2261C21.3258 21.8734 21.524 21.3951 21.524 20.8963V14.3142",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 4.4436C20.4874 4.06953 20.9948 3.85937 21.5238 3.85938C22.0528 3.85938 22.5602 4.06953 22.9342 4.4436C23.3083 4.81767 23.5185 5.32502 23.5185 5.85404C23.5185 6.38306 23.3083 6.89041 22.9342 7.26449L14.0014 16.1973L10.2402 17.1376L11.1805 13.3764L20.1133 4.4436Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/edit_svg.58bd228d59470f6e26c21cfb35208b23.svg";
export { ForwardRef as ReactComponent };